import { Box, Stack, TextField } from '@mui/material'
import { com } from '@eidu/web'
import { PermissionWithId } from '../input/PermissionsInput'
import PermissionsMatrix from '../permissions/PermissionsMatrix'
import SectionHeader from './SectionHeader'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntitySelector = com.eidu.sharedlib.entity.selector.EntitySelector

type PermissionPolicyFormProps = {
  entityTypes: readonly EntityType[]
  name: string
  setName: (name: string) => void
  selectedPermissions: readonly PermissionWithId[]
  setSelectedPermissions: (permissions: readonly PermissionWithId[]) => void
}

const PermissionPolicyForm = ({
  entityTypes,
  name,
  setName,
  selectedPermissions,
  setSelectedPermissions,
}: PermissionPolicyFormProps) => (
  <Stack padding={0} spacing={2} sx={{ width: '100%', overflowX: 'auto' }}>
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, overflow: 'hidden' }}>
      <SectionHeader title="Name" />
      <Box sx={{ p: 2 }}>
        <TextField
          fullWidth
          size="small"
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder="Policy name"
          inputProps={{ 'aria-label': 'Policy name' }}
        />
      </Box>
    </Box>
    <PermissionsMatrix
      entityTypes={entityTypes}
      userSelector={EntitySelector.All}
      selectedPermissions={selectedPermissions}
      setSelectedPermissions={setSelectedPermissions}
    />
  </Stack>
)

export default PermissionPolicyForm
